import './Privacy.css';

function Privacy({ onBack }) {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        {onBack && (
          <button className="privacy-back-btn" onClick={onBack}>
            &larr; Back
          </button>
        )}
        <div className="privacy-header">
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-updated">Last updated: February 2026</p>
        </div>

        <div className="privacy-card">
          <section className="privacy-section">
            <h2>Overview</h2>
            <p>
              AvioTrack is an ADS-B aircraft tracking service. We are committed to protecting your privacy
              and being transparent about the data we collect. This policy explains what information we
              gather and how we use it.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Information We Collect</h2>
            <p>We collect the following information when you create an account and use our service:</p>
            <ul>
              <li>
                <strong>Email address</strong> &mdash; Used as your username for authentication and account
                communications.
              </li>
              <li>
                <strong>Receiver location</strong> &mdash; The geographic coordinates of your ADS-B receiver,
                used to display your receiver on the map and calculate aircraft distances.
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>How We Use Your Data</h2>
            <p>
              We use the information we collect <strong>solely for the purpose of providing the AvioTrack
              service</strong>. Specifically:
            </p>
            <ul>
              <li>Your email address is used for account login and service-related communications.</li>
              <li>Your receiver location is used to position your receiver on the tracking map and
                compute distance calculations for tracked aircraft.</li>
            </ul>
            <p>
              We do not sell, rent, or share your personal data with third parties. We do not use your
              data for advertising, profiling, or any purpose other than operating this service.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Data Storage &amp; Security</h2>
            <p>
              Your data is stored securely and access is restricted to what is necessary for
              the operation of the service. We use industry-standard security measures including
              encrypted connections (HTTPS) and secure authentication (JWT tokens).
            </p>
          </section>

          <section className="privacy-section">
            <h2>Your Rights</h2>
            <p>You may at any time:</p>
            <ul>
              <li>Request access to the personal data we hold about you.</li>
              <li>Request correction or deletion of your data.</li>
              <li>Delete your account, which will remove all associated personal data.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Contact</h2>
            <p>
              If you have any questions about this privacy policy or your data, please contact us
              at <a href="mailto:support@aviotrack.com" className="privacy-link">support@aviotrack.com</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
